"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSiret = exports.isValidSiret = exports.normalizeSiret = void 0;
var normalizeSiret = function (raw) {
    return (raw !== null && raw !== void 0 ? raw : '').replace(/\s/g, '');
};
exports.normalizeSiret = normalizeSiret;
var isValidSiret = function (raw) {
    var normalized = (0, exports.normalizeSiret)(raw);
    if (normalized.length !== 14) {
        return false;
    }
    if (!/^[0-9]+$/.test(normalized)) {
        return false;
    }
    return true;
};
exports.isValidSiret = isValidSiret;
var formatSiret = function (rawSiret) {
    if (!(0, exports.isValidSiret)(rawSiret)) {
        return rawSiret;
    }
    return (0, exports.normalizeSiret)(rawSiret)
        .split('')
        .map(function (digit, index) {
        if (index === 3 || index === 6 || index === 9) {
            return ' ' + digit;
        }
        return digit;
    })
        .join('');
};
exports.formatSiret = formatSiret;
//# sourceMappingURL=siret.js.map